/* Free gift auto-add.

   Keeps one zero-priced gift line in step with the rest of the cart:
   adds it once there is something paid in the cart, removes it if the cart
   drops back to nothing (or below the threshold), and clamps it to qty 1 so
   nobody walks off with four of them.

   Everything is driven off #CartFreeGift, which cart-drawer.liquid renders
   from the theme settings. No config here. */
(function () {
  'use strict';

  var busy = false;
  var lastSignature = '';

  function config() {
    var el = document.getElementById('CartFreeGift');
    if (!el) return null;
    var variantId = parseInt(el.dataset.variantId, 10);
    if (!variantId) return null;
    return {
      variantId: variantId,
      // stored in cents so it compares directly against Shopify's line prices
      minSubtotal: parseInt(el.dataset.minSubtotal, 10) || 0,
    };
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function post(url, payload) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  /* The response is keyed by SECTION id (the filename, e.g. "cart-drawer"),
     not by DOM id. Reading sections['CartDrawer'] here used to miss every
     time, and the old "reload as a fallback" turned that miss into a full
     page refresh on every add to cart. Never reload: a stale drawer for
     one render beats yanking the page out from under the customer. */
  function applySections(sections) {
    if (!sections) return false;
    var swap = function (sectionKey, hostId, selector) {
      var host = document.getElementById(hostId);
      if (!host || !sections[sectionKey]) return false;
      var parsed = new DOMParser().parseFromString(sections[sectionKey], 'text/html').querySelector(selector);
      if (!parsed) return false;
      host.innerHTML = parsed.innerHTML;
      return true;
    };
    var swapped = swap('cart-drawer', 'CartDrawer', '#CartDrawer');
    swap('cart-icon-bubble', 'cart-icon-bubble', '.shopify-section');
    if (swapped) document.dispatchEvent(new CustomEvent('cart-free-gift:repainted'));
    return swapped;
  }

  /* Fallback repaint when a mutation response carried no sections. Never
     publishes a cart-update of its own - that is what would loop. */
  function repaint() {
    /* Build off the current URL so query params survive - dropping them meant
       a theme preview repainted itself from the *published* theme, and the
       swap silently did nothing. */
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
    return fetch(url.toString())
      .then(function (r) {
        return r.json();
      })
      .then(applySections)
      .catch(function () {});
  }

  function reconcile() {
    var cfg = config();
    if (!cfg || busy) return Promise.resolve();

    return getCart()
      .then(function (cart) {
        var gift = null;
        var paidTotal = 0;

        cart.items.forEach(function (item) {
          if (item.variant_id === cfg.variantId) {
            gift = item;
          } else if (item.final_line_price > 0) {
            paidTotal += item.final_line_price;
          }
        });

        var qualifies = paidTotal >= cfg.minSubtotal && paidTotal > 0;

        // Nothing to do is the common case. Bail before touching the cart.
        var signature = [qualifies, gift ? gift.quantity : 0, paidTotal].join(':');
        if (signature === lastSignature) return null;
        lastSignature = signature;

        /* Piggyback the section render on the mutation itself: one round trip
           instead of mutate-then-refetch, so the drawer settles sooner and
           re-renders once, not twice. */
        var sectionsPayload = {
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname + window.location.search,
        };
        if (qualifies && !gift) {
          busy = true;
          return post('cart/add.js', Object.assign({ items: [{ id: cfg.variantId, quantity: 1 }] }, sectionsPayload));
        }
        if (!qualifies && gift) {
          busy = true;
          return post('cart/change.js', Object.assign({ id: gift.key, quantity: 0 }, sectionsPayload));
        }
        if (qualifies && gift && gift.quantity !== 1) {
          busy = true;
          return post('cart/change.js', Object.assign({ id: gift.key, quantity: 1 }, sectionsPayload));
        }
        return null;
      })
      .then(function (changed) {
        if (!changed) return null;
        busy = false;
        lastSignature = '';
        if (applySections(changed.sections)) return null;
        return repaint();
      })
      .catch(function () {
        busy = false;
      });
  }

  function start() {
    reconcile();
    // Dawn publishes cart-update through pubsub; the DOM event is the fallback
    // for anything that only fires that.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(reconcile, 60);
      });
    }
    document.addEventListener('cart:refresh', function () {
      setTimeout(reconcile, 60);
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(reconcile, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
